(function (angular) {
'use strict';

var ctrls = angular.module('adminHelper.controllers', ['timeline.services']);


ctrls.controller("NavController", [
    '$scope', '$location', '$routeParams',
    function($scope, $location, $routeParams) {

        $scope.isActive = function(path) {
            if(path == $routeParams.objects_type) {
                return 'active';
            }
            else {
                return '';
            }
        }
    }
]);


ctrls.controller('ObjectListCtrl', [
    '$scope', '$location', '$routeParams', 'Datetime', 'ObjectList',
    function($scope, $location, $routeParams, Datetime, ObjectList) {

        $scope.objectList = [];
        $scope.count = 0;
        $scope.perPage = 50;
        $scope.Datetime = Datetime;

        var getObjectType = function() {
            return $routeParams.objects_type;
        }

        $scope.getEditLink = function(object) {

            switch(getObjectType()) {

                case 'books':
                    return '/admin/book/book/' + object.id;

                case 'authors':
                    return '/admin/book/author/' + object.id;

                default:
                    return '/admin/book/series/' + object.id;
            }

        };

        $scope.getPage = function() {
            return $routeParams.page ? parseInt($routeParams.page) : 1;
        }

        $scope.getEditDate = function(object) {
            if(object.edit_date !== undefined) {
                return object.edit_date
            }
            else {
                return object.edit
            }
        }

        $scope.getName = function(object) {
            if (object.title !== undefined) {
                return object.title;
            }
            else {
                return object.name;
            }
        }

        $scope.pageUrl = function(p) {
            return '#!/'+ getObjectType() + '/' + p;
        }

        $scope.init = function(userId) {

            var params = {
                id: userId, 
                objects_type: getObjectType(),
                page: $scope.getPage(),
                per_page: $scope.perPage
            };

            ObjectList.get(params, function(data) {
                $scope.objectList = data.results;
                $scope.count = data.count;
            });
        };

        $scope.init(userId);

    }
]);

}(angular));
